// src/context/PageTitleContext.jsx
import React, { createContext, useContext, useState } from 'react';

const PageTitleContext = createContext();

export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error('usePageTitle must be used within PageTitleProvider');
  }
  return context;
};

export const PageTitleProvider = ({ children }) => {
  const [title, setTitle] = useState('Dashboard');
  const [subtitle, setSubtitle] = useState('');

  const updatePageTitle = (newTitle, newSubtitle = '') => {
    setTitle(newTitle);
    setSubtitle(newSubtitle);
    // Update browser tab title
    document.title = `${newTitle} | FuelMonitor`;
  };

  return (
    <PageTitleContext.Provider value={{ title, subtitle, updatePageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};